export const ROLES = ['admin', 'verwalter', 'minijobber', 'kunde'];
/**
 * `missed` is set automatically once the day has passed; `final_missed` is the
 * deliberate decision of the Verwaltung that a task will never be done, it
 * leaves every active list, is never paid and never reported to the customer.
 */
export const TASK_STATUS = ['open', 'done', 'missed', 'final_missed', 'skipped'];
/**
 * The five levels of the object tree. Tasks may hang on any level below the
 * customer; levels may be skipped (a Liegenschaft can own a Bauteil directly).
 */
export const OBJECT_KIND = ['customer', 'site', 'building', 'unit', 'component'];
/**
 * The levels in use (Workshop 23.10.): Kunde, Liegenschaft, Gebäude, Einheit.
 * `component` (Bauteil) only stays in the type for archived history.
 */
export const OBJECT_KIND_IN_USE = ['customer', 'site', 'building', 'unit'];
export const OBJECT_KIND_LABEL = {
    customer: 'Kunde',
    site: 'Liegenschaft',
    building: 'Gebäude',
    unit: 'Einheit',
    component: 'Bauteil',
};
export const OBJECT_KIND_PLURAL = {
    customer: 'Kunden',
    site: 'Liegenschaften',
    building: 'Gebäude',
    unit: 'Einheiten',
    component: 'Bauteile',
};
/** Position in the hierarchy; a parent must always rank above its child. */
export const OBJECT_KIND_RANK = {
    customer: 0,
    site: 1,
    building: 2,
    unit: 3,
    component: 4,
};
/** Which kinds may sit directly below a given kind (levels may be skipped). */
export function allowedChildKinds(parent) {
    if (parent === null)
        return ['customer'];
    // Four levels (Workshop 23.10.): Kunde, Liegenschaft, Gebäude, Einheit. Tasks
    // hang on these directly; the old fifth level "Bauteil" is no longer created.
    if (parent === 'unit')
        return [];
    const rank = OBJECT_KIND_RANK[parent];
    return OBJECT_KIND.filter((kind) => kind !== 'component' && OBJECT_KIND_RANK[kind] > rank);
}
export const ISSUE_STATUS = ['open', 'in_progress', 'waiting', 'done', 'rejected'];
export const ISSUE_PRIORITY = ['low', 'normal', 'high'];
/** Which photos a task requires before it can be completed. */
export const PHOTO_REQUIREMENT = ['none', 'after', 'before_after'];
/** `other`: anything on a task that is neither vorher nor nachher, e.g. a Zählerstand. */
export const PHOTO_KIND = ['before', 'after', 'other', 'issue'];
/** How a completion was recorded, decides how it is labelled in the proof PDF. */
export const COMPLETION_SOURCE = ['app', 'backoffice'];
export const LOCALES = ['de'];
export const DEFAULT_LOCALE = 'de';
/** Occurrences are materialised this many days ahead by the scheduler, so holidays and cover can be planned three months out. */
export const MATERIALIZE_HORIZON_DAYS = 90;
/** Photos are deleted after this retention period (MiLoG / billing cycle). */
export const PHOTO_RETENTION_MONTHS = 24;
/** Hints the task list derives on its own, so nobody keeps them by hand. */
/** Columns the task list can be sorted by. */
export const OCCURRENCE_SORTS = ['due', 'completed', 'status', 'assignee', 'place', 'title', 'unit', 'address', 'result'];
/** How the task list can be grouped: by person, by Liegenschaft, by town. */
/** Task search: all columns, or only Leistung, Objekt und Adresse, Person, Notiz und Ergebnis. */
export const OCCURRENCE_SEARCH_SCOPES = ['task', 'place', 'person', 'text'];
export const OCCURRENCE_GROUPS = ['assignee', 'site', 'city'];
/** Photos per kind on one completion: before, after, other. */
export const MAX_PHOTOS_PER_KIND = 10;
export const TASK_HINTS = ['nicht_zugewiesen', 'krank', 'urlaub', 'vertretung', 'rueckruf'];
export const TASK_HINT_LABEL = {
    nicht_zugewiesen: 'nicht zugewiesen',
    krank: 'krank',
    urlaub: 'Urlaub',
    vertretung: 'Vertretung',
    rueckruf: 'Rückruf',
};
export const ABSENCE_KINDS = ['krank', 'urlaub'];
//# sourceMappingURL=constants.js.map